import { render, staticRenderFns } from "./KBDate.vue?vue&type=template&id=7f33d186&scoped=true&"
import script from "./KBDate.vue?vue&type=script&lang=ts&"
export * from "./KBDate.vue?vue&type=script&lang=ts&"
import style0 from "./KBDate.vue?vue&type=style&index=0&id=7f33d186&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f33d186",
  null
  
)

export default component.exports